import { useQuery } from '@apollo/client';
import EditUserContainerNew from '@nile/client_management/src/Containers/Requester/EditUserContainerNew';
import {
  AIComponent,
  ALL_MODULES,
  AccessControl,
  AddProducts,
  AppContext,
  B1,
  COLOR_MAP,
  DEFAULT_FIELDS_BY_COLUMN_NAME,
  EventEmitter,
  FieldTitle,
  Generator,
  ImagePreviewModal,
  PRIORITY_MAP,
  ProductWorklogs,
  TAB_PAGES,
  TICKET_SOURCE,
  getNotificationTemplateByConstantHook,
  getTranslatedText,
  isAuthorised,
  toast,
  useActivityTracker,
  useIsAuthorisedHook,
  withIntl,
  UnknownTicketActions
} from '@nile/components';
import InlineTextField from '@nile/components/src/Components/InlineEdit/Components/InlineTextField';
import '@nile/components/src/Style/ticketDetailsStyles.scss';
import TicketConfetti from '@nile/components/src/Svg/AnimatedSvg/TicketConfetti.svg';

import {
  AccountClient,
  GET_FIELD,
  GET_STATUS_CONFIGURATION,
  SAVE_TICKET_CONVERSATION,
  TicketClient
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import {
  ClientField,
  ConcurrentViewers
} from '@nile/mangifera/src/Components/Ticket';
import { TicketDetailForm } from '@nile/mangifera/src/Containers/FormContainers';
import ActionsToolbar from '@nile/mangifera/src/Containers/ToolbarContainers/DetailsActionToolbar';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { getTabId } from '@nile/mangifera/src/Pebbles/TabManager';
import { SVGIcon } from '@superops/super-icons';
import {
  ActionList,
  Avatar,
  Badge,
  Button,
  DisplayText,
  Heading,
  Modal,
  Popover,
  Spinner,
  Tooltip as SuperopsTooltip,
  TextStyle
} from '@superops/ui-design-system';
import {
  ContentState,
  EditorState,
  convertFromHTML,
  convertToRaw
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import gql from 'graphql-tag';
import { isEmpty, isEqual } from 'lodash';
import React, { Component, useCallback, useContext, useState } from 'react';
import { Tooltip } from 'react-clone-tippy';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import ClosureModal from '../../Components/Ticket/ClosureModal';
import TicketInsightsAndAudit from '../../Components/Ticket/TicketInsightsAndAudit';
import { TICKET_SCHEMA } from '../../Constants/Tickets';
import { TicketConversation } from './Containers/Conversation';
import { DetailsPageLayout } from './Layouts/DetailsPage.tsx';
import TicketDetailsHeader from './Components/TicketDetailsHeader';
import TicketStateCard from '@nile/mangifera/src/Containers/CardContainers/TicketStateCard.js';
import TicketInsightTriageCard from '@nile/mangifera/src/Containers/CardContainers/TicketInsightTriageCard.tsx';
import { useTicketDetailsConversationStore } from '@nile/mangifera/src/StoreManager/store/ticketDetailsConversationStore';

const NewWrapper = styled.div`
  .section-0 {
    width: ${(props) => (props?.isFormCollapsed ? '75%' : '60%')};
    transition: width 0.2s linear;
    max-width: unset;
  }
  .section-1 {
    flex-grow: unset !important;
    width: ${(props) => (props?.isFormCollapsed ? '0' : '15%')};
    background: var(--sops-bg-white);
    transition: width 0.2s linear;
    position: ${(props) => props?.formState === FORMSTATES.DRAW && 'absolute'};
    border-top-left-radius: ${(props) =>
      props?.formState === FORMSTATES.DRAW && '20px'};
    z-index: ${(props) => props?.formState === FORMSTATES.DRAW && '2'};
    right: ${(props) =>
      props.isFormCollapsed ||
      (props.formState === FORMSTATES.DRAW && !props.isFormCollapsed)
        ? '25%'
        : 'auto'};
    box-shadow: ${(props) =>
      props.formState === FORMSTATES.DRAW &&
      !props.isFormCollapsed &&
      '-4px 0px 20px 0px rgba(0, 0, 0, 0.10)'};
    .ticket-form-header {
      background: ${(props) =>
        props.formState === FORMSTATES.DRAW && '#E6E5FF'};
      border-top-left-radius: ${(props) =>
        props?.formState === FORMSTATES.DRAW && '20px'};
    }
    .ticket-form-wrapper {
      height: ${(props) =>
        props.formState === FORMSTATES.DRAW
          ? 'calc(100% - 180px)'
          : 'calc(100% - 40px)'};
    }
  }
  .section-2 {
    max-width: 25%;
    width: 25%;
    z-index: 3;
  }

  .scheduled-ticket {
    .schedule-icon {
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  @media only screen and (min-width: 1920px) {
    .section-0 {
      width: ${(props) => (props?.isFormCollapsed ? '79%' : '60%')};
    }

    .section-1 {
      width: ${(props) => (props?.isFormCollapsed ? '0' : '18%')};
      right: ${(props) =>
        props.formState === FORMSTATES.DRAW && props.isFormCollapsed
          ? 'calc(22% - 5px)'
          : props.formState === FORMSTATES.DRAW && !props.isFormCollapsed
          ? '22%'
          : 'auto'};
    }
  }
`;

const TicketBg = styled.div`
  background-image: url(${envConfig.imageRoot}svg/${(props) => props.image}.svg);
  height: 55px;
`;

const FORMSTATES = {
  BLOCK: 'block',
  DRAW: 'draw'
};

class TicketDetailsPage extends Component {
  constructor(props) {
    super(props);
    const ticket = props.ticket ?? {
      subject: 'Test ticket man',
      client: { accountId: '' },
      requester: { userId: '' },
      priority: 'High',
      category: 'Help',
      status: 'Closed',
      ticketType: 'Incident',
      impact: 'High',
      urgency: 'High',
      description: ''
    };
    this.state = {
      editMode: false,
      editorState: EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(ticket.description || '')
        )
      ),
      ticket: ticket,
      requesterSheetActive: false,
      updatedRequester: null,
      showConfetti: false,
      confettiType: null,
      subjectEditState: false,
      errorsOnClosure: null,
      closureModalactive: false,
      closureSaveLoading: false,
      failureConversationData: null,
      isFormCollapsed: this.props?.isFormCollapsed || false,
      formState: this.props?.formState || FORMSTATES.BLOCK,
      convertToProject: false
    };
  }

  saveFormState = (formData) => {
    this.props?.saveFormStatesToPersonalisation(formData);
  };

  componentDidMount() {
    if (this.props.setRef) {
      this.props.setRef(this);
    }
    if (this.props?.sendClientEvent) {
      this.props.sendClientEvent('REGISTER_PAGE', this.props?.ticket?.ticketId);
    }
    EventEmitter.subscribe('ticketClosureError', this.getClosureFields);
  }

  componentDidUpdate(prevProps) {
    // for classic view
    if (prevProps.ticket.ticketId !== this.props.ticket.ticketId) {
      if (this.props?.sendClientEvent) {
        this.props.sendClientEvent(
          'REGISTER_PAGE',
          this.props?.ticket?.ticketId
        );
      }
    }

    if (this.props.isClassicView) {
      const keysToCheck = ['technician', 'dormantType', 'operationalStatus'];
      const hasChanged = keysToCheck.some(
        (key) => prevProps.ticket[key] !== this.props.ticket[key]
      );

      if (hasChanged) {
        this.setState({
          ticket: this.props.ticket
        });
      }
    }
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe('ticketClosureError');
    // EventEmitter.dispatch('closeAISummary');
    // We don't want this event to be dispatched as It'll be handled by AI Config
    EventEmitter.unsubscribe('tabChange');
    if (this.props.isClassicView) {
      // used to save conversation and notes draft when switching tickets inside classic view.
      EventEmitter.dispatch('classicTicketSwitch');
    }
  }

  closeForm = () => {
    this.setState({
      isFormCollapsed: true,
      formState: FORMSTATES.DRAW
    });

    const formData = {
      isFormCollapsed: true,
      formState: FORMSTATES.DRAW
    };
    this.saveFormState(formData);
  };

  openForm = () => {
    this.setState({
      isFormCollapsed: false,
      formState: FORMSTATES.BLOCK
    });

    const formData = {
      isFormCollapsed: false,
      formState: FORMSTATES.BLOCK
    };
    this.saveFormState(formData);
  };

  openDrawer = () => {
    this.setState({
      isFormCollapsed: false,
      formState: FORMSTATES.DRAW
    });
  };

  closeDrawer = () => {
    if (this.state.formState === FORMSTATES.DRAW && !this.state.isFormCollapsed)
      this.setState({
        isFormCollapsed: true,
        formState: FORMSTATES.DRAW
      });
  };

  getClosureFields = (errorFields) => {
    this.setState({
      closureModalactive: true,
      errorsOnClosure: {
        ticket: errorFields?.param.ticket,
        status: errorFields?.param?.status,
        fields: errorFields?.param?.fields
      },
      ticket: {
        ...this.state.ticket,
        status: errorFields?.param?.ticket?.status
      }
    });
  };

  static getDerivedStateFromProps(props, state) {
    if (props.ticket.ticketId !== state.ticket.ticketId) {
      return {
        ...state,
        ticket: props.ticket
      };
    }
    return null;
  }

  updateField = (key, field) => {
    let req = { ...this.state.ticket.requester };
    if (key === 'client') {
      req = { userId: '' };
    }
    this.setState({
      ticket: {
        ...this.state.ticket,
        requester: req,
        [key]: field
      }
    });
    this.props.actions.updateParent({
      ...this.state.ticket,
      requester: req,
      [key]: field
    });
  };

  updateSelection = (key, value, callback) => {
    const { suppressCloseNotification, ...ticket } = { ...this.state.ticket };
    this.setState(
      {
        ticket: {
          ...ticket,
          [key]: value
        }
      },
      () => {
        this.save(callback);
      }
    );
  };

  updateConvertToProject = (value) => {
    this.setState({
      convertToProject: value
    });
  };

  updateProperties = (properties, callback) => {
    if (properties?.sop) {
      useActivityTracker({ event: 'Ticket - Associated Runbooks' });
    }
    const ticketState = { ...this.state.ticket };
    if (!properties?.suppressCloseNotification) {
      delete ticketState.suppressCloseNotification;
    }
    this.setState(
      {
        ticket: {
          ...ticketState,
          ...properties
        }
      },
      () => {
        this.save(() => {
          callback && callback();
        });
      }
    );
  };

  updateRequesterData = (changedData) => {
    this.setState({
      updatedRequester: changedData
    });
  };

  // In current approach we sent the status with mandatory fields once it's completed
  // We'll send the conversation using event emitter. But this caused issue in BE.
  updateTicketOnClosure = (ticket, variables) => {
    if (this.state.failureConversationData) {
      const conversationInput = this.state.failureConversationData;
      const ticketInput = variables;
      const params = {
        conversationInput,
        ticketInput
      };
      EventEmitter.dispatch('sendConversationWithMandatoryFields', params);
    } else {
      this.setState({
        closureSaveLoading: true
      });
      this.updateProperties(variables);
    }
  };

  setClosureSaveLoading = (bool) => {
    this.setState({
      closureSaveLoading: bool
    });
  };

  setClosureModalActive = (bool) => {
    this.setState({
      closureModalActive: bool
    });
  };

  updateTicketState = (properties) => {
    // Once ticket properties are sent along with conversation and we get response
    // We'll update the ticket properties using this function
    this.setState({
      ticket: {
        ...this.state.ticket,
        ...properties
      }
    });
  };

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState
    });
    const { ticket } = this.state;
    ticket.description = draftToHtml(
      convertToRaw(this.state.editorState.getCurrentContent())
    );
    this.setState({ ticket: ticket });
  };

  getEditorState(content) {
    return EditorState.createWithContent(
      ContentState.createFromBlockArray(convertFromHTML(content || ''))
    );
  }

  difference = (object, base) => {
    const difference = {};
    for (const prop in object) {
      if (!isEqual(object?.[prop], base?.[prop])) {
        difference[prop] = object[prop];
      }
    }
    return difference;
  };

  getVariables = (diff) => {
    const variables = {};
    for (const prop in diff) {
      variables[prop] = {
        value: diff[prop],
        type: TICKET_SCHEMA[prop],
        inputVariable: prop !== 'id',
        required: prop === 'id'
      };
    }
    return variables;
  };

  setFailureConversationData = (data) => {
    this.setState({
      failureConversationData: data
    });
  };

  getTicketFields = (isMSPProduct) => {
    const updateTicketFields = [
      'ticketId',
      'firstResponseDueTime',
      'firstResponseDueTimeLeft',
      'firstResponseTime',
      'firstResponseViolated',
      'resolutionDueTime',
      'resolutionPauseTime',
      'resolutionDueTimeLeft',
      'resolutionTime',
      'status',
      'impact',
      'urgency',
      'priority',
      'category',
      'subcategory',
      'cause',
      'subcause',
      'resolutionCode',
      'displayId',
      'subject',
      'customFields',
      {
        sop: ['sopId', 'name']
      },
      {
        followers: ['userId', 'name']
      },
      {
        techGroup: ['groupId', 'name']
      },
      {
        technician: ['userId', 'email', 'firstName', 'lastName']
      },
      { requester: ['userId', 'email', 'firstName', 'lastName'] },
      { site: ['name', 'id'] }
    ];
    if (isMSPProduct) {
      updateTicketFields.push(
        { client: ['accountId', 'name'] },
        {
          contractTicketMapping: [
            'inUse',
            'contractId',
            {
              contract: [
                'name',
                'contractId',
                {
                  billableContract: [
                    'contractId',
                    { chargeItem: ['itemId', 'name'] }
                  ]
                }
              ]
            }
          ]
        }
      );
    } else {
      updateTicketFields.push({ department: ['businessFunctionId', 'name'] });
    }
    return updateTicketFields;
  };

  save = (callback) => {
    const { actions, isMSPProduct } = this.props;
    const ticket = { ...this.state.ticket };
    /* ask backend to change id to ticketId */
    const diff = this.difference(this.state.ticket, this.props.ticket);
    if (isEmpty(diff)) {
      callback && callback('success');
      return;
    }
    if (ticket.ticketId) {
      diff.id = ticket.ticketId;
    }
    if (diff.customFields) {
      const updatedDiff = this.difference(
        diff.customFields,
        this.props.ticket.customFields
      );
      diff.customFields = updatedDiff;
    }
    const generator = new Generator({
      operation: 'updateTicket',
      variables: this.getVariables(diff),
      fields: this.getTicketFields(isMSPProduct)
    });
    const mutationString = generator.mutationBuilder();

    TicketClient.mutate({
      mutation: gql`
        ${mutationString.query}
      `,
      variables: diff,
      onCompleted(res) {
        console.log(res);
      },
      onError(res) {
        console.log(res);
      }
    })
      .then((res) => {
        if (res?.data?.updateTicket) {
          if (diff?.customFields) {
            toast('success', 'app.toast.ticket.update.success');
          }
          this.setState({
            ticket: {
              ...this.state.ticket,
              ...res?.data?.updateTicket
            },
            closureSaveLoading: false,
            closureModalActive: false,
            errorsOnClosure: null
          });
          if (this.props.isClassicView) {
            EventEmitter.dispatch('updateClassicCard', res?.data?.updateTicket);
          }

          if (res?.data?.updateTicket?.sop?.sopId) {
            EventEmitter.dispatch(
              'refetchRunbookActionAudit',
              res?.data?.updateTicket?.sop?.sopId
            );
          }

          this.props.actions.updateParent({
            ...this.state.ticket,
            ...res?.data?.updateTicket
          });
        } else {
          callback && callback('error');
          return;
          // toast('error', 'Something went wrong');
        }
        if (this.state.convertToProject) {
          // call redirect Project
          this.redirectToProject();
        }
        callback && callback('success');
        // EventEmitter.dispatch('sendTicketConversation');
      })
      .catch((err) => {
        // toast('error', 'Something went wrong');
        callback && callback('error');
      });
  };

  cancel = () => {
    const { actions, tab } = this.props;
    actions.closeTab(tab);
  };

  setEditorReference = (ref) => {
    this.editorReferece = ref;
  };

  setEditMode = () => {
    const { editMode } = this.state;
    this.setState({ editMode: !editMode });
  };

  updateNewTicketProperties = (newTicketProperties) => {
    this.setState({ ticket: newTicketProperties });
  };

  showConfettiModal = (type) => {
    if (type && !this.state.errorsOnClosure) {
      this.setState({ confettiType: type, showConfetti: true });
      setTimeout(() => {
        this.setState({ confettiType: null, showConfetti: false });
      }, 2500);
    }
  };

  getpriorityImage = (priority) => {
    const priorityId = this.props.priorityValues?.find(
      (el) => el.name === priority
    )?.id;
    return PRIORITY_MAP[priorityId] || 'no_priority';
  };

  setClosureModalActive = (val) => {
    this.setState({
      closureModalActive: val
    });
  };

  setErrorsOnClosure = (errors) => {
    this.setState({
      errorsOnClosure: errors
    });
  };

  setClosureSaveLoading = (val) => {
    this.setState({
      closureSaveLoading: val
    });
  };

  openRequesterSheet = (value) => {
    this.setState({ requesterSheetActive: value });
  };

  updateTicketStatus = (value) => {
    if (value) {
      const updatedTicket = { ...this.state.ticket, status: value };
      this.setState({ ticket: updatedTicket });
    }
  };

  redirectToProject = () => {
    this.setState({ convertToProject: false });

    const ticketDescription = useTicketDetailsConversationStore.getState()
      .ticketDescription;

    this.props.ticketContext.openTab({
      module: ALL_MODULES.projectCreation,
      url: `/project/${this.state.ticket?.ticketId}/new`,
      data: {
        id: 'ticket-to-project',
        module: 'TICKET',
        displayId: this.state.ticket?.displayId,
        ticketId: this.state.ticket?.ticketId,
        title: this.state.ticket?.subject,
        client: {
          accountId: this.state.ticket?.client?.accountId,
          name: this.state.ticket?.client?.name
        },
        site: {
          id: this.state.ticket?.site?.id,
          name: this.state.ticket?.site?.name
        },
        description: ticketDescription
      }
    });
  };

  render() {
    const {
      editorState,
      ticket,
      showConfetti,
      confettiType,
      requesterSheetActive
    } = this.state;
    const {
      intl,
      toolbarHidden,
      children,
      readOnly,
      isClassicView,
      productsToInvoice,
      getItemsToInvoice
    } = this.props;

    const getFollowerContent = () => {
      return (
        <div className="p10 br-5 flex col g10">
          {ticket.followers.map((el) => {
            return (
              <div className="flex center nowrap">
                <div className="mr10">
                  <Avatar
                    initials={`${el.firstName?.[0] || ''}${el.lastName?.[0] ||
                      ''}`}
                    size="extraSmall"
                  />
                </div>
                <div>
                  <FieldTitle className="title">
                    {`${el.firstName} ${el.lastName || ''}`}
                  </FieldTitle>
                </div>
              </div>
            );
          })}
        </div>
      );
    };

    const saveTicketSubject = (value, cb) => {
      if (this.state.ticket?.subject === value) {
        if (cb) cb('success', false);
        return;
      }

      if (value?.trim()) {
        this.setState(
          {
            ticket: { ...this.state.ticket, subject: value.trim() }
          },
          () => {
            this.save(cb);
          }
        );
      } else if (cb) cb('error', false);
    };

    // const confettiMap = {
    //   RESOLVE: <TicketConfetti />,
    //   CLOSE: <TicketConfetti />
    // };

    const getSourceIcon = () => {
      for (const [key, value] of Object.entries(TICKET_SOURCE)) {
        if (value === ticket?.source) {
          return key;
        }
      }
    };
    const sourceIcon = getSourceIcon() || 'InlineError';
    const priorityTooltip = getTranslatedText(
      intl,
      'ticket.list.priority.tooltip'
    );
    const sourceToolTip = getTranslatedText(intl, 'ticket.list.source.tooltip');
    const type = getTranslatedText(intl, 'common.type');

    const redirectToInvoice = (ticketContext) => {
      ticketContext?.openTab({
        module: TAB_PAGES.newInvoiceFromSource,
        id: ticket?.ticketId,
        data: {
          module: 'TICKET',
          action: 'generateInvoiceFromTicket',
          ticket: ticket,
          productsToInvoice: productsToInvoice
        }
      });
    };

    const onSummaryTypeChange = (type) => {
      return {
        variables: {
          input: {
            itemId: ticket?.ticketId,
            itemType: 'TICKET',
            summaryCase: 'OVERALL',
            summaryType: type
          }
        },
        summaryType: type
      };
    };

    return (
      <TicketContext.Consumer>
        {(ticketContext) => {
          return (
            <>
              <Modal
                open={requesterSheetActive}
                onClose={this.openRequesterSheet.bind(this, false)}
                showCloseButton
                fullScreen
              >
                <EditUserContainerNew
                  id={ticket?.requester?.userId}
                  type="edit"
                  newLayout
                  mixpanelSource="Ticket details requester popup"
                  actions={{
                    updateRequesterData: this.updateRequesterData,
                    closeRequesterModal: this.openRequesterSheet.bind(
                      this,
                      false
                    )
                  }}
                />
              </Modal>
              <NewWrapper
                className="full-height ticketDetailsPage ticket-details-revamp"
                isFormCollapsed={this.state.isFormCollapsed}
                formState={this.state.formState}
              >
                <div className="hiddenActions">
                  <TicketInsightTriageCard
                    ticket={{
                      ticketId: ticket?.ticketId,
                      technician: ticket?.technician,
                      aiAgentActionData: ticket?.aiAgentActionData
                    }}
                    listenDefaultAgent
                  />
                </div>
                <DetailsPageLayout
                  header={
                    <>
                      <TicketDetailsHeader
                        ticket={this.state.ticket}
                        saveTicketSubject={saveTicketSubject}
                        setSubjectEditState={(state) => {
                          this.setState({
                            subjectEditState: state
                          });
                        }}
                        subjectEditState={this.state.subjectEditState}
                        priorityValues={this.props.priorityValues}
                        updateSelection={this.updateSelection}
                        refetchTicket={this.props.refetchTicket}
                        updateProperties={this.updateProperties}
                        updateConvertToProject={this.updateConvertToProject}
                        showConfettiModal={this.showConfettiModal}
                        openRequesterSheet={this.openRequesterSheet}
                        concurrentViewers={this.props?.concurrentViewers}
                        isFormCollapsed={this.state.isFormCollapsed}
                        readOnly={readOnly}
                        productsToInvoice={productsToInvoice}
                        isClassicView={this.props.isClassicView}
                        ticketStatus={this.props.ticket?.status}
                      />

                      {this.state.errorsOnClosure && (
                        <>
                          <ClosureModal
                            showCancelBtn={this.state.convertToProject}
                            infoBannerKey={
                              this.state.convertToProject
                                ? 'ticket.convert.to.project.modal.message'
                                : null
                            }
                            title={
                              this.state.convertToProject
                                ? 'ticket.convert.to.project.modal.title'
                                : 'ticket.closure.modal.title'
                            }
                            modalActive={this.state.closureModalactive}
                            setModalActive={this.setClosureModalActive}
                            errorsOnClosure={this.state.errorsOnClosure}
                            setErrorsOnClosure={this.setErrorsOnClosure}
                            onSave={this.updateTicketOnClosure}
                            saveLoading={this.state.closureSaveLoading}
                            onClose={() => {
                              this.setFailureConversationData(null);
                              this.setClosureModalActive(false);
                              EventEmitter.dispatch('closureModalClosed');
                              this.setState({ convertToProject: false });
                            }}
                          />
                        </>
                      )}
                    </>
                  }
                  readOnly={readOnly}
                >
                  {/* Ticket Conversation */}
                  <TicketConversation
                    intl={intl}
                    actions={this.props.actions}
                    ticket={ticket}
                    refetchTicket={this.props.refetchTicket}
                    showConfettiModal={this.showConfettiModal}
                    updateTicketStatus={this.updateTicketStatus}
                    sendClientEvent={this.props?.sendClientEvent}
                    concurrentViewers={this.props?.concurrentViewers}
                    setFailureConversationData={
                      this?.setFailureConversationData
                    }
                    setClosureSaveLoading={this?.setClosureSaveLoading}
                    setClosureModalActive={this?.setClosureModalActive}
                    setErrorsOnClosure={this?.setErrorsOnClosure}
                    updateTicketState={this?.updateTicketState}
                    readOnly={readOnly}
                  />
                  {/* Details and Properties */}
                  {!readOnly && (
                    <div className="full-height full-width">
                      <TicketDetailForm
                        updateSelection={this.updateSelection}
                        updateProperties={this.updateProperties}
                        refetchTicket={this.props.refetchTicket}
                        ticket={ticket}
                        showProgress
                        isFormCollapsed={this.state.isFormCollapsed}
                        closeForm={this.closeForm}
                        openForm={this.openForm}
                        formState={this.state.formState}
                        openDrawer={this.openDrawer}
                        closeDrawer={this.closeDrawer}
                      />
                    </div>
                  )}
                  {/* Insights */}

                  {!readOnly && (
                    <div className="fhp">
                      <TicketInsightsAndAudit
                        ticket={ticket}
                        updateSelection={this.updateSelection}
                        updatedRequester={this.state.updatedRequester}
                        refetchTicket={this.props.refetchTicket}
                        openRequesterModal={this.openRequesterSheet.bind(
                          this,
                          true
                        )}
                        getItemsToInvoice={getItemsToInvoice}
                      />
                    </div>
                  )}

                  {readOnly && !ticket?.client ? (
                    ticket.dormantType !== 'DELETED' ? (
                      <TicketStateCard
                        refetchTicket={this.props.refetchTicket}
                        ticket={ticket}
                        cardType={'UnknownTicket'}
                      />
                    ) : ticket?.operationalStatus === 'DORMANT' ? (
                      <TicketStateCard
                        refetchTicket={this.props.refetchTicket}
                        ticket={ticket}
                        cardType={'DELETED'}
                      />
                    ) : null
                  ) : null}
                </DetailsPageLayout>
                <ImagePreviewModal />
                <Modal
                  activator={<></>}
                  open={showConfetti}
                  small
                  showCloseButton={false}
                >
                  <div className="p40">
                    <div className="flex actr jctr w100">
                      <TicketConfetti />
                    </div>
                    <p className="tcenter f-16 mt40">
                      {confettiType === 'CLOSE' && (
                        <TextStyle weight="Bold">
                          <FormattedMessage id="ticket.confetti.ticket.closed" />
                        </TextStyle>
                      )}
                      {confettiType === 'RESOLVE' && (
                        <TextStyle weight="Bold">
                          <FormattedMessage id="ticket.confetti.ticket.resolved" />
                        </TextStyle>
                      )}
                    </p>
                  </div>
                </Modal>
              </NewWrapper>
            </>
          );
        }}
      </TicketContext.Consumer>
    );
  }
}

function StatusChange(props) {
  const { intl, ticket, showConfettiModal, readOnly } = props;
  let isFeatureAuthorised = useIsAuthorisedHook('tickets.edit');
  if (typeof readOnly !== 'undefined') {
    isFeatureAuthorised = !readOnly;
  }
  const {
    loading: ticketStatusConfigLoading,
    error: statusConfigError,
    data: statusConfigData
  } = useQuery(GET_STATUS_CONFIGURATION, {
    skip: !isFeatureAuthorised
  });

  const { data, loading, error } = useQuery(GET_FIELD, {
    client: AccountClient,
    variables: {
      input: {
        module: ALL_MODULES.ticket,
        columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
      }
    },
    skip: !isFeatureAuthorised
  });

  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((active) => !active),
    []
  );
  if (loading) return <Spinner size="small" color="inkLightest" />;
  if (error) return <div>error...</div>;
  const activator = (
    <AccessControl
      roleToCheck="tickets.edit"
      render={
        <Button
          id="statusChange"
          primary
          onClick={togglePopoverActive}
          icon={<SVGIcon name="TicketOutline" color={COLOR_MAP.white} />}
        >
          <div className="flex center">
            <B1>{ticket.status}</B1>
            <div className="ml8 fx center">
              <SVGIcon name="ArrowDown" color={COLOR_MAP.white} />
            </div>
          </div>
        </Button>
      }
      fallback={
        <Button
          id="statusChange"
          primary
          icon={<SVGIcon name="TicketOutline" color={COLOR_MAP.white} />}
        >
          <div className="flex center">
            <B1 className="ml8">{ticket.status}</B1>
          </div>
        </Button>
      }
    />
  );

  const showConfetti = (name) => {
    const statusType = statusConfigData?.getStatusConfiguration.find(
      (el) => el.status.name === name
    )?.configuration;
    showConfettiModal(statusType);
  };

  const changeStatus = (selectedStatus) => {
    props.updateSelection(
      'status',
      selectedStatus.value,
      showConfetti.bind(this, selectedStatus.value)
    );
    sessionStorage.removeItem('closeTicketClicked');
    sessionStorage.removeItem('suppressCloseNotificationClicked');
    if (selectedStatus.details?.constants === 'CLOSE') {
      sessionStorage.setItem('closeTicketClicked', true);
    }
    togglePopoverActive();
  };

  const changeStatusToClosed = (selectedStatus) => {
    props.updateProperties(
      {
        suppressCloseNotification: true,
        status: selectedStatus.value
      },
      showConfetti.bind(this, selectedStatus.value)
    );
    sessionStorage.removeItem('closeTicketClicked');
    sessionStorage.setItem('suppressCloseNotificationClicked', true);
    togglePopoverActive();
  };

  const getStatusListContent = (el) => {
    if (el.details?.constants === 'CLOSE') {
      return (
        <div onClick={() => changeStatus(el)} className="flex actr">
          <div>{el?.value}</div>
          <div
            onClick={(event) => {
              event.stopPropagation();
              changeStatusToClosed(el);
            }}
            className="fx actr mlauto ptr"
          >
            <Tooltip
              html={
                <div className="p3 f12">
                  {getTranslatedText(
                    intl,
                    'ticket.action.closeWithoutNotification'
                  )}
                </div>
              }
              delay={200}
              duration={250}
              position="bottom"
              distance={10}
              inertia
              trigger="mouseenter"
              animation="shift"
              animateFill={false}
            >
              <Badge
                radial
                status="attention"
                icon={<SVGIcon name="NotificationsBellCrossed" size="sm" />}
              />
            </Tooltip>
          </div>
        </div>
      );
    }
    return <div onClick={() => changeStatus(el)}>{el?.value}</div>;
  };

  const fldOptions = data?.getField?.options || data?.getField?.fieldOptions;
  return (
    <div className="vignesh">
      <Popover
        active={popoverActive}
        activator={activator}
        preferredAlignment="right"
        onClose={togglePopoverActive}
      >
        <ActionList
          actionRole="menuitem"
          items={fldOptions?.map((el) => ({
            content: getStatusListContent(el)
          }))}
        />
      </Popover>
    </div>
  );
}

function FieldInfo(props) {
  const { icon, action, params } = props;
  return (
    <div className="min-w-200 mr8 nowrap ml-8 max-w-250">
      <TextStyle variation="subdued" weight="Bold">
        {props.label}
      </TextStyle>
      <div className="flex center info mt-8">
        <SVGIcon name={icon} size="sm" />
        <div className="ellipsis">
          {action ? (
            <Link
              fontWeight="bold"
              removeUnderline
              onClick={action ? action.bind(this, params) : ''}
            >
              {props.value || '--'}
            </Link>
          ) : (
            <TextStyle weight="Bold">{props.value || '--'}</TextStyle>
          )}
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line no-underscore-dangle
const _TicketDetailsPage = withIntl(TicketDetailsPage);

export { _TicketDetailsPage as TicketDetailsPage };
